<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <v-text-field
          v-model="profile.name"
          :label="$t('profile.name')"
          :rules="[rules.required, backEndValidation('name')]"
        ></v-text-field>

        <v-autocomplete
          v-model="profile.language"
          :items="languages"
          item-value="code"
          item-text="name"
          :label="$t('profile.language')"
          :rules="[rules.required, backEndValidation('language')]"
        ></v-autocomplete>
        <v-autocomplete
          v-model="profile.number_format"
          :items="locales"
          item-value="code"
          item-text="name"
          :label="$t('profile.number-format')"
          :rules="[rules.required, backEndValidation('number_format')]"
        ></v-autocomplete>
        <v-autocomplete
          v-model="profile.date_format"
          :items="locales"
          item-value="code"
          item-text="name"
          :label="$t('profile.date-format')"
          :rules="[rules.required, backEndValidation('date_format')]"
        ></v-autocomplete>
        <v-autocomplete
          v-model="profile.timezone"
          :items="timezones"
          :label="$t('profile.timezone')"
          :rules="[rules.required, backEndValidation('timezone')]"
        ></v-autocomplete>
        <v-text-field
          v-model="profile.email"
          :label="$t('profile.email-address')"
          :rules="[rules.required, rules.email, backEndValidation('email')]"
          readonly
        ></v-text-field>
      </v-form>
    </v-col>
    <v-col>
      <v-btn color="primary" v-on:click="updateProfile()" :loading="loading">
        <v-icon left>mdi-pencil</v-icon> {{ $t("profile.update") }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment-timezone";
import { rules } from "./../mixins/rules";
export default {
  name: "EditProfile",
  mixins: [rules],
  data: () => ({
    timezones: moment.tz.names(),
    loading: false
  }),
  computed: {
    profile: {
      get() {
        return this.$store.getters["profileStore/getProfile"];
      }
    },
    locales: {
      get() {
        return this.$store.getters["localizationStore/localeStore/getList"];
      }
    },
    languages: {
      get() {
        return this.locales.filter(i => i.language);
      }
    }
  },
  methods: {
    updateProfile() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("profileStore/updateProfile", {
            ...this.profile,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch("profileStore/refreshProfile");
  }
};
</script>

<style scoped></style>
